<template>
  <el-dialog
    v-drag:common
    title="导入边界"
    :visible="visible"
    :show-close="false"
    width="400px"
  >
    <el-form
      :model="formData"
      class="demo-form-inline"
      ref="boundaryImport"
      :rules="rules"
    >
      <el-form-item label="风场边界" label-width="80px" prop='fileId'>
        <el-upload
          ref="uploadFile"
          :limit="1"
          :action="action"
          :data="{ file: 'file', apiKey: getToken(), type: 8 }"

          :on-success="
            (response, file, fileList) =>
              onFileUploadSuccess(response, file, fileList, 'fileId')
          "
          :file-list="fileListMap.fileIdList"
          :on-remove="
            (file, fileList) => removeFile(file, fileList, 'fileId')
          "
          :on-change="
            (file, fileList) => handleChange(file, fileList, 'fileId')
          "
          accept=".kmz"
        >
          <ct-button type="primary" size="small">点击上传</ct-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <ct-button :btn-click="close" size="small"
        >取 消</ct-button
      >
      <ct-button type="primary" :btn-click="submit" size="small"
        >确 定</ct-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from '@/utils';
import { uploadBoudaryFile } from '../service';
import to from 'await-to-js';
export default {
  props: ['visible'],
  data() {
    return {
      formData: {
        projectId: null,
        fileId: null
      },
      action: `${process.env.VUE_APP_API_HOST_WINDDATA}/windfarm/station/uploadFile`,
      rules: {
        fileId: [
          { required: true, message: '请上传风场边界!', trigger: 'change' },
        ],
      },
      fileIdsMap: {},
      fileListMap: {
        fileIdList: [],
      },  
    };
  },
  mounted(){
      
  },
  onShow(){
  },
  computed: {},
  watch: {
    'visible':  function (val) {
      if(val !== true){
        this.$refs.boundaryImport.resetFields();
        this.$refs.uploadFile.clearFiles();
      }
    }
  },
  methods: {
    getToken,
    close() {
      this.$refs.uploadFile.clearFiles();
      this.$emit('close');
    },
    submit() {
      console.log(this.fileIdsMap, 'we');
      this.$refs.boundaryImport.validate(async (valid) => {
        if (valid) {
          const [err] = await to(
            uploadBoudaryFile({
              projectId: this.$route.query.projectId,
              ...this.fileIdsMap,
            })
          );

          if (!err) {
            // this.close();
            this.$emit('uploadConfirm');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    async onFileUploadSuccess(response, file, fileList, key) {
      if (response.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success',
        });
        const { files } = response.data;
        this.formData[key] = files;
        this.fileIdsMap[key] = files.fileId;
        console.log('this.fileIdsMap[key]',this.fileIdsMap[key]);
        this.$refs.boundaryImport.validate();
        return;
      }

      setTimeout(() => {
        this.fileIdsMap[key] = '';
        this.formData[key] = '';
        this.fileListMap[key + 'List'] = [];

        this.$message({
          message: response?.message || '上传文件失败',
          type: 'error',
        });
      }, 50);
    },

    removeFile(file, fileList, key) {
      this.fileIdsMap[key] = '';
      this.fileListMap[key + 'List'] = fileList;
      this.formData[key] = fileList;
    },
    handleChange(file, fileList, key) {
      this.fileListMap[key + 'List'] = fileList.slice(-5);//取最后五个
      //this.fileListMap[key + 'List'] = [file];
    },
    onExceed() {
      this.$message.error('只允许上传一个文件， 请先删除再上传');
    }
  },
};
</script>
<style lang="less" scoped></style>
